<template>
  <small-modal
    :title="$t('create.step2.addTagsToVideosModal.title')"
    class="add-title-modal"
    :fit-content="true"
    @close="close"
  >
    <div class="add-title-modal-container">
      <banner-modal
        class="banner-modal"
        :title="bannerTitle"
        :text="bannerText"
      >
      </banner-modal>
      <TagsManager
        :videos="selectedVideoObjects"
        :is-video-library="true"
        :video-library="videoLibrary"
      />
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "../shared/SmallModal";
import BannerModal from "../shared/BannerModal.vue";
import TagsManager from "@/components/campaign-manager/TagsManager.vue";

export default {
  components: {
    SmallModal,
    BannerModal,
    TagsManager,
  },
  props: {
    selectedVideos: {
      type: Array,
      default: () => [],
    },
    videoLibrary: {
      type: Array,
      default: () => [],
    },
    isFromSingleVideo: {
      type: Boolean,
      default: false,
    },
    videoName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    selectedVideoObjects() {
      return this.videoLibrary.filter((video) =>
        this.selectedVideos.includes(video._id)
      );
    },
    prefilledTitle() {
      const titles = this.selectedVideoObjects.map((video) => video.videoTitle);

      const allTitlesSame = titles.every((title) => title === titles[0]);
      return allTitlesSame ? titles[0] : "";
    },
    bannerTitle() {
      if (this.isFromSingleVideo) {
        return this.$t("create.step2.addTagsToVideosModal.singleTitle");
      } else {
        return this.$t("create.step2.addTagsToVideosModal.title");
      }
    },
    bannerText() {
      if (this.isFromSingleVideo) {
        return this.videoName;
      } else {
        return this.$t("create.step2.addTagsToVideosModal.text");
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-modal {
  margin-bottom: 24px;
  min-width: 480px;
}
</style>
